import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation PauseSegmentCampaign($campaignId: ID!, $segmentId: ID!) {
    pauseContinuousOptimizationCampaignSegment(campaignId: $campaignId, segmentId: $segmentId) {
      id
      status
    }
  }
`;

export const pauseSegmentCampaign = ({ campaignId, segmentId }) =>
  executeGqlMutation({
    mutation: MUTATION,
    variables: { campaignId, segmentId },
  }).then(({ data }) => getSingleProp(data));
